import React, { createContext, useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isBrowser } from "../services/browser"
import { getCart, getSubTotal } from "../services/cartHelper"

const PROMOTION_THRESHOLD_USD = 850;
const PROMOTION_THRESHOLD_GBP = 700;
const PROMOTION_THRESHOLD_EUR = 750;

const locale = process.env.LANG_TAG;

export const MINIMUM_AMOUNT =
  locale === "en-US" ? PROMOTION_THRESHOLD_USD : locale === "en-GB" ? PROMOTION_THRESHOLD_GBP : PROMOTION_THRESHOLD_EUR

export const PromotionContext = createContext()

export const PromotionContextProvider = (props) => {
  const { home, promotionCollection } = useStaticQuery(
    graphql`
      query {
        home: contentfulHome {
          freeGiftPromotion
        }
        promotionCollection: shopifyCollection(handle: { eq: "surprise-gift" }) {
          products {
            id
            handle
            title
          }
        }
      }
    `
  )

  const checkIfPromotionActive = () => {
    let active = false
    if (isBrowser) {
      if (!home.freeGiftPromotion) {
        active = false
      } else {
        let cartData = getCart()
        let cart
        let total = 0

        if (cartData) {
          cart = JSON.parse(cartData)
          total = getSubTotal(cart)
        }

        if (total >= MINIMUM_AMOUNT) {
          active = true
        } else {
          active = false
        }
      }

      return active
    }
  }

  const checkIfFreeGiftActive = () => {
    let active = false
    if (isBrowser()) {
      let cartData = getCart()
      let cart

      if (cartData) {
        cart = JSON.parse(cartData)
      }
      if (cart) {
        const cartItems = cart.items

        if (cartItems && checkIfPromotionActive()) {
          const collectionProductHandles = promotionCollection?.products?.map(
            (item) => item.handle
          )
          active = cartItems.some((item) =>
            collectionProductHandles.includes(item.handle)
          )
        }
      }
    }

    return active
  }

  const checkIfPromotionItem = (handle) => {
    const collectionProductHandles = promotionCollection?.products?.map(
      (item) => item.handle
    )

    if (collectionProductHandles.includes(handle?.trim())) {
      return true
    } else {
      return false
    }
  }

  return (
    <PromotionContext.Provider
      value={{
        checkIfFreeGiftActive,
        checkIfPromotionItem,
        checkIfPromotionActive,
      }}
    >
      {props.children}
    </PromotionContext.Provider>
  )
}

export const usePromotionContext = () => {
  return useContext(PromotionContext)
}
